const initFlipModal = () => {
	let flipModal = document.querySelector('#flip-modal')

	if (flipModal !== null) {
		if (window.innerHeight > window.innerWidth) {
			flipModal?.classList.remove('hidden')
		}
		window.onresize = () => {
			if (window.innerHeight > window.innerWidth) {
				flipModal?.classList.remove('hidden')
			} else {
				flipModal?.classList.add('hidden')
			}
		}
	}
}
export { initFlipModal }
